var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"acea-row row-middle",attrs:{"id":"footer"}},[_c('div',{staticClass:"copyright"},[_vm._v("©2019-2025 樂雅健康管理系统 All right reserved")])])
}]

export { render, staticRenderFns }